export const ReactionStatus = {
    NotView : 0,
    View : 1,
    Reject : 2,
    Invitation : 3,
    SentToStudent : 4,
    StudentAccepted : 5,
    StudentRejected : 6
}